module.exports = __webpack_public_path__ + "img/values-4.daa73c27.jpg";